import Search from "@mui/icons-material/Search";
import Input from "components/Input";
import React, { useEffect, useState } from "react";

const SearchInput = ({
  search,
  setSearch,
  t = (d) => d,
  classes = "",
  placeholder,
  width = "100%",
  height,
  ...rest
}) => {
  const [searchText, setSearchText] = useState(search);

  useEffect(() => {
    if (!search || search !== searchText) setSearchText(search);
  }, [search]);

  return (
    <Input
      width={width}
      placeholder={placeholder ?? "Search"}
      height={height ?? 38}
      icon={<Search className="c-gray" />}
      classes={classes}
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
      onKeyDown={(e) => e.key === "Enter" && setSearch(searchText)}
      t={t}
      iconLeft
      {...rest}
    />
  );
};

export default SearchInput;
